import { Component, Input } from '@angular/core';
import { Chat } from '../../models/chat';
import { ChatService } from '../../services/chat.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { MatIconModule } from '@angular/material/icon';
import { FeedbackDetailComponent } from '../feedback-detail/feedback-detail.component';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    MatIconModule,
    FeedbackDetailComponent,
    CommonModule
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackMainComponent {

  // message
  @Input() message: Chat = { sender: '', text: '', responseId: '', feedback: 'None', messageType: '', additionalFeedbackFlag: false, answerSelected: false, selectedMultiselectOptions: [], multiselectOptions: [], products: [] }
  // conversation id
  @Input() uniqueConversationId = '';
  // feedback reason
  feedbackReason = '';
  // selected reason
  feedbackReasonText = '';

  constructor(private chatService: ChatService, private snackBarService: SnackBarService, private analyticsService: AnalyticsService) { }

  feedbackForMessage(feedback: string) {
    if (this.message['feedback'] === feedback)
      this.message['feedback'] = 'None';
    else
      this.message['feedback'] = feedback;
    if (this.message['feedback'] === 'thumbs down') {
      this.initializeFeedback(true);
      this.sendFeedback();
    } else {
      this.initializeFeedback(false);
      this.sendFeedback();
    }

    // Track feedback event in Firebase Analytics
    this.analyticsService.trackEvent('message_feedback', {
      feedback: this.message['feedback'], // 'thumbs up', 'thumbs down', or 'None'
      timestamp: new Date().toISOString(),
    });
  }

  initializeFeedback(flag: boolean) {
    // initialize to empty string
    this.feedbackReasonText = '';
    this.feedbackReason = '';
    this.message['additionalFeedbackFlag'] = flag;
  }

  sendFeedback() {
    const responseId = this.message['responseId'];
    const feedback = this.message['feedback'];
    this.postFeedback(responseId, feedback);
  }

  postFeedback(responseId: string, feedback: string, feedbackReason?: string, feedbackReasonText?: string) {
    this.chatService.feedback(responseId, this.uniqueConversationId, feedback, feedbackReason, feedbackReasonText).subscribe({
      next: () => {
        // success message if any
      },
      error: (error) => {
        this.snackBarService.showErrorMessage(error.error.statusCode);
      }
    });
  }

}
